<template>
  <div v-if="loopData" class="company-other">
    <h1 class="otherJob">
  {{ cpLang("jd.more_job_from") }}
    </h1>
    <div class="job-area company-list" style="margin: 0 -30px;">
      <div class="row" style="max-width:100%;margin: 0 auto;">
        <template v-for="job in loopData">
          <a
            v-if="job.id !== id"
            :key="job.id"
            :href="`/job/${getFullSlug(job.jobtitletext,job.id)}`"
            target="_blank"
            class="item col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-4"
          >
            <JobCard
              :id="job.id"
              :is-blind="job.blindAd"
              :page="job.page"
              :requestid="job.requestid"
              :priority="job.priority"
              :logo="job.logoname"
              :url="job.url"
              :tag="job.tag"
              :score="job.score"
              :title="job.jobtitletext"
              :company="job.displayname"
              :industry="job.industrydesc"
              :cluster="job.clusterdesc"
              :joblevel="job.managerialleveldesc"
              :employmenttype="job.employmentstatusdesc"
              :salary="concatSalary(job.minsalary,job.maxsalary,job.salarytype,job.showsalary)"
              :location="job.locationdesc"
              :activationdate="job.activationdate"
              @save="saveBookmark"
              @unsave="unsaveBookmark"
            />
          </a>
        </template>
      </div>
      <div v-if="cdata.positions.length > 7" class="row text-center">
        <a :href="`/company-${getFullSlug(loopData[0].displayname)}-jobs/1`" class="btn more-jobs">
        {{ cpLang("jd.more_job") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import JobCard from '~/components/search/JobCard'
import commonHelper from '~/assets/js/commonHelper.js'

export default {
  components: {
    JobCard
  },
  props: {
    cdata: {
      default: null,
      type: Object
    },
    id: {
      default: null,
      type: String
    }
  },
  data: function () {
    return {
      data: {
        loopData: null,
        isMore: false,
        max: 6
      }
    }
  },
  created() {
    const vm = this
    const { positions } = this.cdata
    let keys = Object.keys(positions)
    keys = keys.filter((i) => {
      return String(positions[i].id) !== String(vm.id)
    })
    keys = keys.slice(0, 6)
    const data = []
    for (const x in keys) {
      data.push(positions[keys[x]])
    }
    this.loopData = data
    if (positions.length > this.max + 1) {
      this.isMore = true
    }
  },
  methods: {
    saveBookmark: function (id) {
      // sync bookmark status
      document.querySelectorAll('#job-' + id).forEach(function (item) {
        const bm = item.querySelector('.bookmark')
        bm.classList.add('active')
        bm.title = 'Unsave'
      })
    },
    unsaveBookmark: function (id) {
      // sync bookmark status
      document.querySelectorAll('#job-' + id).forEach(function (item) {
        const bm = item.querySelector('.bookmark')
        bm.classList.remove('active')
        bm.title = 'Save'
      })
    },
    getFullSlug(title, id) {
      const fullSlug = id ? commonHelper.getSlug(title) + '-' + id : commonHelper.getSlug(title)
      return fullSlug
    },
    concatSalary(min, max, type, show) {
      if (show === 'N') {
        return ''
      }
      let str = ''
      if (min && max) {
        str = min + '-' + max
      } else {
        str = min || max
      }
      if (str !== '' && type) {
        str += ' / ' + type
      }
      if (!str) {
        return ''
      }
      return str.toString()
    }
  }
}

</script>

<style lang="scss">
  .company-other {
    text-align: left;
    margin-top: 30px;
  }

  .otherJob {
    color: #333333;
    font-size: 16px;
    line-height: 21px;
    font-weight: bold;
    background: #D5DEE6;
    margin: -5px -30px;
    text-align: center;
    padding: 30px 0 10px 0;
  }

  .company-list {
    .row {
      padding: 30px
    }
  }

  .more-jobs{
    background: #2B59C3 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding: 5px 20px;
    margin: 0 auto;
    color: white;
    &:hover{
      color:white
    }
  }

</style>
